import React from 'react';
import PropTypes from 'prop-types';

const ArticleContentCover = ({ imageCover }) => {
  return (
    <section className="aricle-content__cover-wrapper" data-scroll-section>
      <div
        className="aricle-content__cover-overflow"
        data-scroll=""
        data-scroll-speed="-1"
      >
        <img
          src={`https://admin.shoschool.com${imageCover?.url}`}
          alt="Обложка статьи"
          className="aricle-content__cover"
        />
      </div>
    </section>
  );
};

ArticleContentCover.propTypes = {
  imageCover: PropTypes.object,
};

export default ArticleContentCover;
